import {Action, di} from "@dp-instant/core";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {useInjection} from "@dp-instant/ui";
import {BotPresetsModel} from "@game/coregame/model/BotPresetsModel";
import {useEffect, useState} from "preact/hooks";
import {TypesFlow} from "@dp-instant/interfaces";

export const DebugPanelGamePlay = () => {
    const model = useInjection<GameModel>(TypesGame.model);
    const botPresetsModel = useInjection<BotPresetsModel>(TypesGame.botPresetsModel);

    const initialState = {
        name: botPresetsModel.currentPresetName
    };
    const [state, setState] = useState(() => initialState);

    useEffect(() => {
        setState(state => ({...state, name: botPresetsModel.currentPresetName}));
    }, [botPresetsModel.currentPresetName]);

    return (
        <div
            style={
                "pointer-events: auto; position: absolute; right: 10px; bottom: 80px; display: flex; flex-direction: column;"
            }
        >
            <span>{di.get<GameModel>(TypesGame.model).currentContinent.data.id}</span>
            <span>{state.name}</span>
            {/* <button onClick={() => di.get<Action>(TypesFlow.LevelEnd).run()}>LevelEnd</button> */}
            {/* <button onClick={() => di.get<Action>(TypesFlow.LevelRestart).run()}>Restart</button> */}
            <button onClick={() => model.endStage(false)}>Loose</button>
            <br />
            <button onClick={() => model.endStage(true)}>Win Stage</button>
            <button onClick={() => model.endStage(true, true)}>Win Level</button>
            <button
                onClick={() => {
                    model.cookie.clear();
                    di.get<Action>(TypesFlow.LevelStart).run();
                }}
            >
                Clear progress
            </button>
            {/* <button onClick={async () => console.log(await model.createFieldScreenShot())}>
                Screen shot
            </button> */}
            {/* <button onClick={() => lazyGet<Action>(TypesFlow.LevelNext)?.run()}>Play</button> */}
        </div>
    );
};
